// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__aXsS4","price":"Cart_price__CjjTi","count":"Cart_count__ZG4I-"};